import React, { useEffect, useState } from "react";
import "../../Assets/Styles/offCanvas.css";
import { useNavigate } from "react-router-dom";
import { sendEnquiryQuestion } from "../../Services/api";

const ServiceEnquiryOffCanvas = ({
  isOpen,
  cartAppId,
  vendorId,
  serviceId,
  category,
  toggleOffCanvas,
}) => {
  const navigate = useNavigate();
  const [enquiryQuestion, setEnquiryQuestion] = useState("");

  function sendEnquiry() {
    let param = {
      cart_app_id: cartAppId,
      vendor_id: vendorId,
      service_id: serviceId,
      enquiry_question: enquiryQuestion,
    };
    sendEnquiryQuestion(param).then((res) => {
      if (res.data?.status == "1") {
        setEnquiryQuestion("");
        toggleOffCanvas();
        navigate(`/chat/enquery/${res.data?.enquiry_id}`);
      }
    });
  }

  return (
    <div className="d-flex justify-content-center">
      <div
        className={`offcanvas offcanvas-bottom serviceEnquiryModal ${
          isOpen ? "show" : ""
        }`}
        tabIndex="-1"
        aria-labelledby="serviceEnquiryModalLabel"
        style={{
          position: "fixed",
          zIndex: 10000,
          bottom: "0px",
          left: "50%",
          transform: "translateX(-50%)",
          width: "390px",
        }}
      >
        <div className="offcanvas-body small" style={{ overflow: "hidden" }}>
          <div className="ff-poppins-semiBold fs-14">Service Enquiry</div>
          <div className="ff-poppins-regular fs-12">{category}</div>

          <textarea
            className="form-control ff-poppins-regular fs-14 mt-2 mb-2 enquiryTextarea"
            rows={5}
            placeholder="Please provide details of your service enquiry."
            maxLength={120}
            value={enquiryQuestion}
            onChange={(ev) => setEnquiryQuestion(ev.target.value)}
          />

          <div
            className={`d-flex justify-content-end ff-poppins-regular mt-1 mb-1 ${
              enquiryQuestion?.length == 120 ? "text-danger" : "primary-text"
            }`}
          >
            {enquiryQuestion?.length} / 120
          </div>

          <button
            type="button"
            className={`${
              enquiryQuestion?.length >= 20 && enquiryQuestion?.length <= 120
                ? "primary-bg"
                : "opacity-75 secondaryslot-bg"
            } btn-type-1 ff-poppins-semiBold fs-14 w-100 border-0 text-white justify-content-center d-flex align-items-center mb-2`}
            onClick={sendEnquiry}
            disabled={enquiryQuestion?.length < 20}
          >
            Send Enquiry
          </button>
        </div>
      </div>
    </div>
  );
};

export default ServiceEnquiryOffCanvas;
